/** Centralized React Query cache keys to avoid scattered string literals. */
export const queryKeys = {
  ORDERS: ["orders"] as const,
  TRAILERS: ["trailers"] as const,
  TRAILER_EVENTS: ["trailer-events"] as const,
  YARD_CHECKOUT_ORDERS: ["yard-checkout-orders"] as const,
  YARD_CHECKIN_ORDERS: ["yard-checkin-orders"] as const,
  LOCATIONS: ["locations"] as const,
};
